import { Mui } from "@osu/react-ui";
import DatePicker from "./DatePicker";
import { add, addWeeks, isAfter, isBefore, sub } from 'date-fns'

const createValidationFields = ({
  minRangeDays = 3,
  startMinDate,
  endValue,
  startMaxDate,
  startValue,
  endMinDate,
  endMaxDate,
  startReferenceDate: _startReferenceDate,
  endReferenceDate: _endReferenceDate
}) => {
  let startReferenceDate = _startReferenceDate, endReferenceDate = _endReferenceDate
  const defaultMinDate = sub(new Date(), { years: 7 })
  const defaultMaxDate = add(new Date(), { years: 5 })
  const startValidation = {
    minDate: startMinDate || defaultMinDate,
    maxDate: startMaxDate || defaultMaxDate,
    shouldDisableDate: endValue ? (date) => !isBefore(date, endValue) : undefined,
  }
  const endValidation = {
    minDate: endMinDate ? endMinDate : startValue ? add(startValue, { days: minRangeDays }) : defaultMinDate,
    maxDate: endMaxDate || defaultMaxDate,
    shouldDisableDate: startValue ? (date) => !isAfter(date, startValue) : undefined,
  }

  if(!startReferenceDate && !endReferenceDate) {
    startReferenceDate = startValidation.minDate
    endReferenceDate = startValidation.maxDate
  } if(startReferenceDate && !endReferenceDate) {
    endReferenceDate = addWeeks(startReferenceDate, 1)
  }

  return {
    startValidation,
    endValidation,
    startReferenceDate,
    endReferenceDate
  }
}

function DateRange(props = {}) {
  const {
    id,
    label,
    description,
    required,
    startValue,
    endValue,
    onStartChange,
    onEndChange,
    startLabel = "Start",
    endLabel = "End",
    startError,
    endError,
    startHelperText,
    endHelperText,
    startName,
    endName,
    format,
    startMinDate,
    startMaxDate,
    endMinDate,
    endMaxDate,
    minRangeDays,
    startReferenceDate: _startReferenceDate,
    endReferenceDate: _endReferenceDate,
    ...rest
  } = props;

  const descriptionId = `${id}-description`;
  const labelId = `${id}-label`;

  const handleStartChange = (value, name) => {
    onStartChange(value, name);
    if (endValue && value && new Date(value) > new Date(endValue)) {
      onEndChange(value, name);
    }
  };

  const handleEndChange = (value, name) => {
    if (startValue && value && new Date(value) < new Date(startValue)) {
      return;
    }
    onEndChange(value, name);
  };

  const {
    startValidation,
    endValidation,
    startReferenceDate,
    endReferenceDate
  } = createValidationFields({
    minRangeDays,
    startMinDate,
    endValue,
    startMaxDate,
    startValue,
    endMinDate,
    endMaxDate,
    startReferenceDate: _startReferenceDate,
    endReferenceDate: _endReferenceDate,
  })

  return (
    <Mui.FormGroup {...rest}>
      {label && (
        <Mui.FormLabel
          component="legend"
          id={labelId}
          required={required}
          sx={{ mb: 1 }}
        >
          {label}
        </Mui.FormLabel>
      )}
      {description && (
        <Mui.Typography id={descriptionId} variant="body2" sx={{ mb: 1 }}>
          {description}
        </Mui.Typography>
      )}
      <Mui.Box sx={{ display: 'flex', gap: 2 }}>
        <DatePicker
          id={`${id}-start`}
          label={startLabel}
          required={required}
          value={startValue}
          setValue={handleStartChange}
          error={startError}
          helperText={startHelperText}
          format={format}
          name={startName}
          minDate={startMinDate}
          maxDate={startMaxDate}
          referenceDate={startReferenceDate}
          {...startValidation}
        />
        <DatePicker
          id={`${id}-end`}
          label={endLabel}
          required={required}
          value={endValue}
          setValue={handleEndChange}
          error={endError}
          helperText={endHelperText}
          format={format}
          name={endName}
          referenceDate={endReferenceDate}
          {...endValidation}
        />
      </Mui.Box>
    </Mui.FormGroup>
  );
}

export default DateRange;
